import { Injectable, Signal } from '@angular/core';
import { GearService } from '../../services/gear.service';
import { GearType } from '../../models/gear-type';

@Injectable()
export abstract class CustomGearService<T> extends GearService<T> {
  abstract readonly type: Signal<GearType>;
  abstract readonly title: Signal<string>;
}
